export const normalizePop = (pop: number | null | undefined): number | null =>
    pop != null && Number.isFinite(pop) ? pop : null;
